import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-landingpage',
  templateUrl: './landingpage.component.html',
  styleUrls: ['./landingpage.component.scss'],
  standalone: false
})
export class LandingpageComponent {

  @ViewChild('demoSection') demoSection!: ElementRef;

  constructor(
    private router: Router
  ) {}

  ngOnInit(): void {
  }

  goToRegister() {
    this.router.navigate(['/register'], { queryParams: { referrer: 'lp4' }});
  }

  scrollToDemo() {
    this.demoSection.nativeElement.scrollIntoView({ behavior: 'smooth' });
  }
}
